import React from 'react';
import { styles } from '../styles'

const Line = () => <div style={{...styles.line}}></div>

export default Line